import { render } from "./BaseSpinner.vue?vue&type=template&id=6e30deab&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=6e30deab&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e30deab"]])

export default __exports__